<template>
    <div class="fill-height">
      <ConfirmationDialog
        :show="confirm.show"
        :title="confirm.title"
        :message="confirm.message"
        :confirmText="confirm.confirmText"
        :persistent="confirm.persistent"
        :icons="icons"
        @close="handleCancel()"
        @cancel="handleCancel()"
        @confirm="handleConfirm()"
      />
      <!--Remote actions-->
    <v-row class="fill-height">
      <v-col md="8" class="content-height overflow-y-auto mt-2">
        <div class="content-card">
        <span class="content-title">{{ $t('assets.devices.deviceInfo.settings.reboot.header') }}</span>
        <v-card elevation="0" rounded class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.reboot.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.reboot.description') }}</span>
          </v-col>
          <v-col
              md="4"
              class="d-flex justify-end">
            <v-btn
                md="4"
                depressed
                class="text-capitalize font-weight-regular subtitle-2"
                color="primary"
                width="100%"
                :loading="this.loaders['instant-reboot']"
                :disabled="!getSelectedDevice.online"
                @click="openConfirm('instant-reboot')">
              {{ $t('assets.devices.deviceInfo.settings.reboot.button') }}
            </v-btn>
          </v-col>
        </v-card>
        <v-card elevation="0" rounded class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.shutdown.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.reboot.description') }}</span>
          </v-col>
          <v-col
              md="4"
              class="d-flex justify-end">
            <v-btn
                md="4"
                depressed
                color="primary"
                class="text-capitalize font-weight-regular subtitle-2"
                width="100%"
                :disabled="!getSelectedDevice.online"
                :loading="this.loaders['instant-reboot']"
                @click="openConfirm('instant-power-off')">
                {{ $t('assets.devices.deviceInfo.settings.shutdown.button') }}
            </v-btn>
          </v-col>
        </v-card>
        <v-card elevation="0" rounded class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.rd.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.rd.description') }}</span>
          </v-col>
          <v-col
              md="4"
              class="d-flex justify-end">
            <v-btn
                md="4"
                depressed
                class="text-capitalize font-weight-regular subtitle-2"
                color="primary"
                width="100%"
                :loading="this.getLoaderRd"
                @click="startRD(device.uuid)"
                :disabled="!getSelectedDevice.online"
            >{{ $t('assets.devices.deviceInfo.settings.rd.button') }}
            </v-btn>
          </v-col>
        </v-card>
        <v-card elevation="0" rounded class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.screenshot.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.screenshot.description') }}</span>
          </v-col>
          <v-col
              md="4"
              class="d-flex justify-end">
            <v-btn
                md="4"
                depressed
                class="text-capitalize font-weight-regular subtitle-2"
                color="primary"
                width="100%"
                :loading="this.getLoaderScreenshot"
                @click="takeScreenshot(device.space_uuid, device.uuid)"
                :disabled="!getSelectedDevice.online">{{ $t('assets.devices.deviceInfo.settings.screenshot.button') }}
            </v-btn>
          </v-col>
        </v-card>
        <v-card elevation="0" rounded class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.confTool.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.confTool.description') }}</span>
          </v-col>
          <v-col
              md="4"
              class="d-flex justify-end">
              <v-tooltip
              top
              :disabled="!isWindowsComputer"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                style="width: 100%;"
              >
                <v-btn
                  md="4"
                  depressed
                  class="text-capitalize font-weight-regular subtitle-2"
                  color="primary"
                  width="100%"
                  :loading="getLoaderConfTool"
                  :disabled="!getSelectedDevice.online || isWindowsComputer"
                  @click="openConfirm('hardware-configurator')"
                >
                  {{ $t('assets.devices.deviceInfo.settings.confTool.button') }}
                </v-btn>
              </span>
            </template>

            <span>This action is not supported for Windows Computer devices.</span>
          </v-tooltip>
          </v-col>
        </v-card>
        <v-card elevation="0" rounded class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.touchscreenCalibration.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.touchscreenCalibration.description') }}</span>
          </v-col>
          <v-col
              md="4"
              class="d-flex justify-end">
              <v-tooltip
              top
              :disabled="!isWindowsComputer"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                style="width: 100%;"
              >
                <v-btn
                  md="4"
                  depressed
                  class="text-capitalize font-weight-regular subtitle-2"
                  color="primary"
                  width="100%"
                  :loading="getLoaderTouchscreenCalibration"
                  :disabled="!getSelectedDevice.online || isWindowsComputer"
                  @click="openConfirm('touchscreen-calibration')"
                >
                  {{ $t('assets.devices.deviceInfo.settings.touchscreenCalibration.button') }}
                </v-btn>
              </span>
            </template>
            <span>This action is not supported for Windows Computer devices.</span>
          </v-tooltip>
          </v-col>
        </v-card>
        </div>
        <!--Systems settings-->
         <div class="content-card">
        <span class="content-title">{{ $t('assets.devices.deviceInfo.settings.rssh.header') }}</span>
        <v-card elevation="0" rounded class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.disable.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.disable.description') }}</span>
          </v-col>
          <v-col
              md="4"
              class="d-flex justify-end">
            <v-switch
                md="4"
                color="error"
                ref="disabledSwitch"
                v-model="disableDeviceSwitch"
                @change="() => { disableDevice() }">
            </v-switch>
          </v-col>
        </v-card>
           <v-card elevation="0" rounded class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.debug.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.debug.description') }}</span>
          </v-col>
          <v-col
              md="4"
              class="d-flex justify-end">
              <v-switch
                md="4"
                color="info"
                v-model="deviceDebugMode"
                @change="onDebugToggle"
            >
            </v-switch>
          </v-col>
        </v-card>
        <v-card elevation="0" rounded class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.replacement.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.replacement.description') }}</span>
          </v-col>
          <v-col
              md="4"
              class="d-flex justify-end">
            <v-btn
                md="4"
                depressed
                class="text-capitalize font-weight-regular subtitle-2"
                color="error"
                width="100%"
                @click="openConfirm('replacement')">{{ $t('assets.devices.deviceInfo.settings.replacement.button') }}
            </v-btn>
          </v-col>
        </v-card>
         </div>
        <!--Vision settings-->
        <div class="content-card" v-if="getSelectedDevice.device_type_name === 'Linux Computer'">
        <span class="content-title">{{ $t('assets.devices.deviceInfo.settings.vision.header') }}</span>
        <v-card elevation='0' rounded v-if="getSelectedDevice.device_type_name === 'Linux Computer'" class="d-flex align-center justify-space-between mt-2">
          <v-col
              md="8"
              class="d-flex flex-column">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.vision.visionWorkers.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.vision.visionWorkers.description') }}</span>
          </v-col>
          <v-col
          md="4"
          class="d-flex justify-end">
          <div class="loader-container">
            <v-switch
              color="info"
              v-model="deviceVisionMode"
              :disabled="visionSwitchDisabled"
              :input-value="visionSwitchValue"
              @change="toggleVision"
            />
            <v-progress-circular
              v-if="isLoading"
              indeterminate
              size="22"
              width="2"
              color="primary"
              class="loader-absolute"
            ></v-progress-circular>
          </div>
        </v-col>
        </v-card>
        <VisionPendingAlert
          :show="visionPendingStatus"
          variant="workers"
        />
        <v-card elevation="0" rounded v-if="getSelectedDevice.device_type_name === 'Linux Computer'" class="d-flex align-center justify-space-between mt-2">
        <v-row class="d-flex align-center justify-space-between mx-0">
          <v-col cols="12" md="8" class="d-flex flex-column pr-4">
            <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.vision.visionOffline.title') }}</span>
            <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.vision.visionOffline.description') }}</span>
          </v-col>
          <v-col cols="12" md="4" class="d-flex justify-end align-center">
            <div class="loader-container">
              <v-switch
                v-model="deviceVisionOfflineMode"
                :disabled="visionOfflineSwitchDisabled"
                @change="enableVisionOffline"
                color="info"/>
            </div>
          </v-col>
        </v-row>
      </v-card>
       <VisionPendingAlert
          :show="visionPendingOfflineStatus"
          variant="offline"
        />
      </div>
        <!--Advanced settings-->
        <div class="content-card">
            <span class="content-title">{{ $t('assets.devices.deviceInfo.settings.rssh.header') }}</span>
            <v-card rounded elevation="0" v-if="isAdmin || sysDev" class="d-flex align-center justify-space-between mt-2">
              <v-col
                  md="8"
                  class="d-flex flex-column">
                <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.rssh.title') }}</span>
                <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.rssh.description') }}</span>
              </v-col>
              <v-col
                  md="4"
                  class="d-flex justify-end">
                <v-btn
                    md="4"
                    depressed
                    class="text-capitalize font-weight-regular subtitle-2"
                    color="primary"
                    width="100%"
                    :loading="this.getLoadersRssh"
                    @click="startRSSH(device.uuid)"
                    :disabled="!getSelectedDevice.online">
                    {{ $t('assets.devices.deviceInfo.settings.rssh.button') }}
                </v-btn>
              </v-col>
            </v-card>
                <v-card rounded elevation="0" v-if="sysDev" class="d-flex align-center justify-space-between mt-2">
              <v-col
                  md="8"
                  class="d-flex flex-column">
                <span class="subtitle-1 text-primary">{{ $t('assets.devices.deviceInfo.settings.hvnc.title') }}</span>
                <span class="body-2 text-secondary">{{ $t('assets.devices.deviceInfo.settings.hvnc.description') }}</span>
              </v-col>
              <v-col
                  md="4"
                  class="d-flex justify-end">
              <v-btn
                  depressed
                  color="primary"
                  width="100%"
                  class="text-capitalize font-weight-regular subtitle-2"
                  :loading="this.getLoaderVnc"
                  :disabled="!getSelectedDevice.online"
                  @click="startHeadlessVnc(device.uuid)"
                >
                  {{ $t('assets.devices.deviceInfo.settings.hvnc.button') }}
                </v-btn>
              </v-col>
        </v-card>
        </div>
      </v-col>
      <v-divider
          class="d-none d-md-flex"
          vertical/>
      <v-col
          cols="12"
          sm="12"
          md="4"
          class="ml-n3 py-0 pr-0 content-height overflow-y-auto">
          <v-card
            height="72"
            class="px-4 pb-5 pt-3 "
            flat>
          <v-card-text class="pa-0">
            <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">{{
                $t('assets.devices.deviceInfo.info.debugModeTitle')
              }}</span>
            <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
              <v-chip
                small
                style="border-radius: 4px !important; height: 16px;"
                :text-color="isDebugModeEnabled ? 'white' : disabledChipTextColor"
                :color="isDebugModeEnabled ? 'success' : 'gray'"
                class="notify-chip">{{  isDebugModeEnabled ? $t('assets.devices.deviceInfo.settings.labels.enabled') : $t('assets.devices.deviceInfo.settings.labels.disabled') }}</v-chip>
            </v-list-item-title>
          </v-card-text>
        </v-card>
        <v-divider/>
        <v-card
            v-if="getSelectedDevice.device_type_name === 'Linux Computer'"
            height="72"
            class="px-4 pb-5 pt-3 "
            flat>
          <v-card-text class="pa-0">
            <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">{{
                $t('assets.devices.deviceInfo.info.visionEnableTitle')
              }}</span>
            <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
              <v-chip
                small
                :color="getVisionChipColor(getSelectedDevice.vision_workers)"
                :text-color="getVisionChipColor(getSelectedDevice.vision_workers) !== 'gray' ? 'white' : disabledChipTextColor"
                class="notify-chip"
              >
                {{ formatVisionLabel(getSelectedDevice.vision_workers) }}
              </v-chip>
            </v-list-item-title>
          </v-card-text>
        </v-card>
         <v-divider/>
        <v-card
            v-if="getSelectedDevice.device_type_name === 'Linux Computer'"
            height="72"
            class="px-4 pb-5 pt-3 "
            flat>
          <v-card-text class="pa-0">
            <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">{{$t('assets.devices.deviceInfo.info.visionEnableOfflineTitle')}}</span>
            <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
              <v-chip
                small
                :color="getVisionChipColor(getSelectedDevice.vision_offline_mode)"
                :text-color="getVisionChipColor(getSelectedDevice.vision_offline_mode) !== 'gray' ? 'white' : disabledChipTextColor"
                class="notify-chip"
              >
                {{ formatVisionLabel(getSelectedDevice.vision_offline_mode) }}
              </v-chip>
            </v-list-item-title>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DevicesApi from '@/services/api/Devices';
import { mdiClose } from '@mdi/js';
import { mapGetters, mapActions } from 'vuex';
import ConfirmationDialog from './ConfirmationDialog.vue';
import VisionPendingAlert from '../../VisionPendingAlert.vue';


export default {
  props: ['device', 'selectedTab', 'channel'],
  components: {
    ConfirmationDialog,
    VisionPendingAlert
  },
  data: () => ({
       confirm: {
        show: false,
        action: null,         // 'instant-reboot' | 'instant-power-off' | 'replacement' | 'disable'
        title: '',
        message: '',
        confirmText: 'Confirm',
        persistent: false,
        payload: null,        // optional extra data (e.g., space_uuid)
        onConfirm: null,
        onCancel: null,
      },
    icons: {
      mdiClose: mdiClose,
    },
    localDevice: {},
    selectedDebugInfo: {},
    dialog: false,
    loaders: {
      'instant-reboot': false,
      'instant-power-off': false,
      'generate-replacement': false,
    },
    dialogs: {
      'instant-power-off': false,
      'disable': false,
      'replacement': false,
      'instant-reboot': false
    },
    disableDeviceSwitch: false,
    deviceDebugMode: false,
    deviceVisionMode: null, // current state: disabled, enable_pending, enabled, disable_pending
    deviceVisionOfflineMode: null,
    timeouts: {
      screenshot: null,
      rd: null,
      rssh: null,
      vnc: null,
      confTool: null,
      touchscreenCalibration: null
    }
  }),
  mounted() {
    // toogle button for vision workers state 
    this.localDevice = { ...this.device };
    if (this.isVisionEnabling) {
      this.deviceVisionMode = true;
    } else {
      this.deviceVisionMode = false;
    }
    //toogle button for vision offline mode  state upon component creation 
    if(this.isVisionOfflineEnabling){
      this.deviceVisionOfflineMode = true;
    }else{
      this.deviceVisionOfflineMode = false;
    }

    if (!this.localDevice.enabled) {
      this.disableDeviceSwitch = true;
    }
    this.deviceDebugMode = !!this.getSelectedDevice?.debug_mode;

  },

  metaInfo() {
    return {
      title: `Settings - ${this.device.name}` || "",
    }
  },
  computed: {
    ...mapGetters({
      getSelectedDevice: 'devices/getSelectedDevice',
      getOnlineStatus: 'devices/getOnlineStatus',
      getLoadersRssh: 'devices/loaderRssh',
      getLoaderRd: 'devices/loaderRd',
      getLoaderScreenshot: 'devices/loaderScreenshot',
      getLoaderVnc:'devices/loaderVnc',
      getLoaderConfTool: 'devices/loaderConfTool',
      getLoaderTouchscreenCalibration: 'devices/loaderTouchscreenCalibration',
      user: 'accounts/getUser'
    }),
    isWindowsComputer() {
      return this.getSelectedDevice?.device_type_name === 'Windows Computer';
    },
    isVisionEnabling() {
        const s = this.localDevice?.vision_workers || '';
        return ['enabled', 'enable_pending', 'enable_requested'].includes(s);
      },
    isVisionOfflineEnabling(){
      const s = this.localDevice?.vision_offline_mode || '';
        return ['offline_mode_enabled', 'offline_mode_enable_pending', 'offline_mode_enable_requested'].includes(s);
    },
    sysDev(){
      return this.user.sys_dev;
    },
    isAdmin(){
      return this.user.super_admin;
    },
     getCheckVisionOfflineStatus(state) {
        return state.filterCheck.vision_offline_mode;
      },
    visionPendingStatus(){
      return this.getSelectedDevice.vision_workers === 'disable_pending' || this.getSelectedDevice.vision_workers === 'enable_pending';
    },
    visionPendingOfflineStatus(){
       return this.getSelectedDevice.vision_offline_mode === 'offline_mode_disable_pending' || this.getSelectedDevice.vision_offline_mode === 'offline_mode_enable_pending';
    },
    isLoading() {
      const state = this.getSelectedDevice.vision_workers;
      return state === 'enable_requested' || state === 'disable_requested';
    },
    visionSwitchValue() {
      return ['enabled', 'enable_pending', 'enable_requested'].includes(this.getSelectedDevice.vision_workers);
    },
    visionSwitchDisabled() {
      const w = this.getSelectedDevice.vision_workers || '';
      const o = this.getSelectedDevice.vision_offline_mode || '';

      const workersBusy = ['enable_pending', 'disable_requested', 'enable_requested', 'disable_pending'].includes(w);
      const offlineBusy = ['offline_mode_enable_pending', 'offline_mode_disable_requested', 'offline_mode_enable_requested', 'offline_mode_disable_pending'].includes(o);

      // Ako želiš da su ekskluzivni i kad je offline uključen, dodaj:  || o === 'offline_mode_enabled'
      return workersBusy || offlineBusy /* || o === 'offline_mode_enabled' */;
    },

    visionOfflineSwitchDisabled() {
      const w = this.getSelectedDevice.vision_workers || '';
      const o = this.getSelectedDevice.vision_offline_mode || '';

      const workersBusy = ['enable_pending', 'disable_requested', 'enable_requested', 'disable_pending'].includes(w);
      const offlineBusy = ['offline_mode_enable_pending', 'offline_mode_disable_requested', 'offline_mode_enable_requested', 'offline_mode_disable_pending'].includes(o);

      // Ako želiš da su ekskluzivni i kad su workers uključeni, dodaj: || w === 'enabled'
      return offlineBusy || workersBusy /* || w === 'enabled' */;
    },

    visionEnabled() {
    return this.getSelectedDevice?.vision_workers ?? false;
  },
    disabledChipTextColor() {
      return this.$vuetify.theme.dark ? 'white' : 'grey darken-1';
    },
    isDebugModeEnabled() {
      return !!this.getSelectedDevice?.debug_mode;
    },
    visionStatusProperty() {
      return this.visionEnabled === 'enable_pending' ? 'enabled but activation' : 'disabled but deactivation';
    },
  },
  watch: {
    getSelectedDevice: {
      handler() {
        this.selectedDebugInfo = Object.assign({}, this.getSelectedDevice);
      },
      deep: true
    },
    'getSelectedDevice.debug_mode': {
      immediate: true,
      handler(val) {
        this.deviceDebugMode = !!val;
      },
    },
    getLoaderRd(newVal) {
      if (!newVal) {
        this.clearRequestTimeout('rd');
      }
    },
    getLoadersRssh(newVal) {
      if (!newVal) {
        this.clearRequestTimeout('rssh');
      }
    },
    getLoaderScreenshot(newVal) {
      if (!newVal) {
        this.clearRequestTimeout('screenshot');
      }
    },
    getLoaderVnc(newVal) {
      if (!newVal) {
        this.clearRequestTimeout('vnc');
      }
    },
    getLoaderConfTool(newVal) {
      if (!newVal) {
        this.clearRequestTimeout('confTool');
      }
    },
    getLoaderTouchscreenCalibration(newVal) {
      if (!newVal) {
        this.clearRequestTimeout('touchscreenCalibration');
      }
    },

  },
  methods: {
    ...mapActions({
      addAlert: "global/addAlert",
      getSpecificDevice: "devices/getSpecificDevice",
    }),
     openConfirm(action, opts = {}) {
      const name = this.getSelectedDevice?.name || 'this device';
      const map = {
        'instant-reboot': {
          title: 'Reboot',
          message: `Are you sure you want to reboot ${name}?`,
          confirmText: 'Reboot',
          persistent: false,
          onConfirm: () => this.powerAction(this.device.uuid, 'instant-reboot')
        },
        'instant-power-off': {
          title: 'Shutdown',
          message: `Are you sure you want to shutdown ${name}?`,
          confirmText: 'Shut Down',
          persistent: false,
          onConfirm: () => this.powerAction(this.device.uuid, 'instant-power-off')
        },
        'hardware-configurator': {
          title: this.$t('assets.devices.deviceInfo.settings.confTool.confirm.title'),
          message: this.$t('assets.devices.deviceInfo.settings.confTool.confirm.message'),
          confirmText: this.$t('assets.devices.deviceInfo.settings.confTool.confirm.button'),
          persistent: false,
          onConfirm: () => this.runConfTool()
        },
        'touchscreen-calibration': {
          title: this.$t('assets.devices.deviceInfo.settings.touchscreenCalibration.confirm.title'),
          message: this.$t('assets.devices.deviceInfo.settings.touchscreenCalibration.confirm.message'),
          confirmText: this.$t('assets.devices.deviceInfo.settings.touchscreenCalibration.confirm.button'),
          persistent: false,
          onConfirm: () => this.triggerTouchscreenCalibration()
        },
        'replacement': {
          title: 'Generate replacement code',
          message: `Are you sure you want to replace ${name}?`,
          confirmText: 'Generate',
          persistent: false,
          onConfirm: () => this.generateReplacementCode(this.device.space_uuid, this.device.uuid)
        },
        'disable': {
          title: 'Disable',
          message: `Are you sure you want to disable ${name}?`,
          confirmText: 'Disable',
          persistent: true,
          onConfirm: () => this.changeEnabledStatus(false),
          onCancel: () => { this.disableDeviceSwitch = false; }
        }
      };

      const base = map[action];
      this.confirm = {
        show: true,
        action,
        title: base.title,
        message: base.message,
        confirmText: base.confirmText,
        persistent: base.persistent,
        payload: opts.payload || null,
        onConfirm: base.onConfirm,
        onCancel: base.onCancel || null
      };
    },

    handleConfirm() {
      try { this.confirm.onConfirm && this.confirm.onConfirm(); }
      finally { this.confirm.show = false; }
    },

    handleCancel() {
      try { this.confirm.onCancel && this.confirm.onCancel(); }
      finally { this.confirm.show = false; }
    },
    // changes chip color based on property status for vision workers and vision offline mode
    getVisionChipColor(mode) {
      switch (mode) {
        case 'enabled':
        case 'offline_mode_enabled': return 'success';
        case 'enable_pending':
        case 'disable_pending':
        case 'offline_mode_enable_pending':
        case 'offline_mode_disable_pending': return 'warning';
        case 'enable_requested':
        case 'disable_requested': 
        case 'offline_mode_enable_requested':
        case 'offline_mode_disable_requested': return 'info';
        default: return 'gray';
      }
    },
    formatVisionLabel(value) {
      if (!value) return '';
      return value.replace(/^offline_mode_/, '').replace(/_/g, ' ');
    },
    startRD(uuid) {
      this.$store.commit("devices/SET_LOADER_RD", true);
      DevicesApi.startRD(uuid)
        .then(() => {
          this.setRequestTimeout('rd');
        });
    },
    startHeadlessVnc(uuid) {
      this.$store.commit("devices/SET_LOADER_VNC", true);
      DevicesApi.startHeadlessVnc(uuid)
        .then(() => {
          this.setRequestTimeout("vnc");
        })
        .catch((err) => {
          this.$store.commit("devices/SET_LOADER_VNC", false);
          this.addAlert({
            type: "error",
            message: "Headless VNC failed to start. Please try again later.",
          });
          console.error("Headless VNC error:", err);
        });
    },

    runConfTool() {
      const device = this.getSelectedDevice;
      this.$store.commit("devices/SET_LOADER_CONFTOOL", true);
      DevicesApi.runHardwareConfigurator(device.space_uuid, device.uuid)
        .then(() => {
          this.setRequestTimeout('confTool');
        })
        .catch((err) => {
          this.$store.commit("devices/SET_LOADER_CONFTOOL", false);
          this.addAlert({
            type: "error",
            message: "Configurator tool failed to start. Please try again later.",
          });
          console.error("Configurator tool error:", err);
        });
    },

    triggerTouchscreenCalibration() {
      const device = this.getSelectedDevice;
      this.$store.commit("devices/SET_LOADER_TOUCHSCREENCALIBRATION", true);
      DevicesApi.triggerTouchscreenCalibration(device.space_uuid, device.uuid)
        .then(() => {
          this.setRequestTimeout('touchscreenCalibration');
        })
        .catch((err) => {
          this.$store.commit("devices/SET_LOADER_TOUCHSCREENCALIBRATION", false);
          this.addAlert({
            type: "error",
            message: "Touchscreen calibration failed to start. Please try again later.",
          });
          console.error("Touchscreen calibration error:", err);
        });
    },

    startRSSH(uuid) {
      this.$store.commit("devices/SET_LOADER_RSSH", true);
      DevicesApi.startRSSH(uuid)
        .then(() => {
          this.setRequestTimeout('rssh');
        });
    },
    takeScreenshot(space_uuid, uuid) {
      this.$store.commit("devices/SET_LOADER_SCREENSHOT", true);
      DevicesApi.takeScreenshot({ space_uuid, uuid }, {
        action: 'screenshot',
      }).then(() => {
        this.setRequestTimeout('screenshot');
      });
    },
    setRequestTimeout(action) {
      this.clearRequestTimeout(action);
      this.timeouts[action] = setTimeout(() => {
        this.handleTimeout(action);
      }, 30000);
    },
    clearRequestTimeout(action) {
      if (this.timeouts && this.timeouts[action]) {
        clearTimeout(this.timeouts[action]);
        this.timeouts[action] = null;
      } else {
        console.log(`No timeout found for ${action}`);
      }
    },
    handleTimeout(action) {
      this.$store.commit(`devices/SET_LOADER_${action.toUpperCase()}`, false);
      this.addAlert({
        type: "warning",
        message: `Service temporarily unavailable, try again later.`,
      });
    },
    changeEnabledStatus(bool) {
      DevicesApi.toggleEnabled(this.localDevice.space_uuid, this.localDevice.uuid, {
        enabled: bool,
      }).then(() => {
        this.disableDeviceSwitch = !bool;
        this.dialogs['disable'] = false;
        this.localDevice.enabled = bool;
        this.$store.commit('updateDevice', this.localDevice);
        this.addAlert({
          type: 'success',
          message: `Device ${bool ? 'enabled' : 'disabled'} successfully.`,
        });
      }).catch(err => {
        this.disableDeviceSwitch = false;
        this.addAlert({
          type: 'error',
          message: `Failed to toggle status. Check console.`,
        });
        console.log(err);
      });
    },
    disableDevice() {
      if (this.localDevice.enabled) {
        this.dialogs['disable'] = true;
      } else {
        this.disableDeviceSwitch = false;
        this.changeEnabledStatus(true);
      }
    },
    onDebugToggle(enabled) {
      const device = this.getSelectedDevice;
      if (!device?.uuid) return;

      const debug_mode = !!enabled;
      // Keep switch where the user put it until device GET returns real state.
      this.deviceDebugMode = debug_mode;

      DevicesApi.toggleDebug(device.space_uuid, device.uuid, { debug_mode })
        .catch((err) => {
          console.error(err);
          // No response body on success either — always sync from device endpoint.
          this.getSpecificDevice({ route: "device", uuid: device.uuid });
        });
    },
    toggleVision() {
      const enable = this.visionEnabled === 'disabled' || this.visionEnabled === 'disable_pending';
      this.$store.commit('devices/UPDATE_DEVICE_VISION_STATE', {
        uuid: this.getSelectedDevice.uuid,
        vision_workers: enable ? 'enable_requested' : 'disable_requested'
      });
      DevicesApi.toggleVision(this.getSelectedDevice.space_uuid, this.getSelectedDevice.uuid, { enabled: enable })
        .catch(() => {
          this.$store.commit('devices/UPDATE_DEVICE_VISION_STATE', {
            uuid: this.getSelectedDevice.uuid,
            vision_workers: enable ? 'disabled' : 'enabled'
          });
          this.addAlert({
            type: 'error',
            message: 'Failed to toggle vision status.',
          });
        });
    },
    enableVisionOffline() {
      const currentState = this.getSelectedDevice.vision_offline_mode;
      const isEnabling = currentState === 'offline_mode_disabled' || currentState === 'offline_mode_disable_pending';
      this.$store.commit('devices/UPDATE_DEVICE_VISION_OFFLINE_STATE', {
        uuid: this.getSelectedDevice.uuid,
        vision_offline_mode: isEnabling ? 'offline_mode_enable_requested' : 'offline_mode_disable_requested'
      });
      DevicesApi.toogleVisionOffline(this.getSelectedDevice.space_uuid, this.getSelectedDevice.uuid, {
        enabled: isEnabling
      }).catch(() => {
        this.$store.commit('devices/UPDATE_DEVICE_VISION_OFFLINE_STATE', {
          uuid: this.getSelectedDevice.uuid,
          vision_offline_mode: isEnabling ? 'offline_mode_disabled' : 'offline_mode_enabled'
        });
        this.addAlert({
          type: 'error',
          message: 'Failed to toggle vision status.',
        }); 
      });
    },

    generateReplacementCode(space_uuid, uuid) {
      this.dialogs['replacement'] = false;
      this.loaders['generate-replacement'] = true;
      DevicesApi.generateReplacementCode(space_uuid, uuid, {}).then((response) => {
        this.addAlert({
          type: 'success',
          message: `Replacement code generated successfully.`,
        });
        this.loaders['generate-replacement'] = false;
        let payload = {
          uuid: this.getSelectedDevice.uuid,
          data: response.data
        };
        this.$store.commit("devices/UPDATE_DEVICE_UUID", payload);
        this.$emit("switchTab", "general");
      }).catch(err => {
        this.addAlert({
          type: 'error',
          message: `An error occurred. Check console.`,
        });
        console.log(err);
      });
    },
    powerAction(uuid, action) {
      this.loaders[action] = true;
      this.dialogs[action] = false;
      DevicesApi.powerAction(uuid, { action }).then(response => {
        this.addAlert({
          type: 'success',
          message: `Action successful.`,
        });
        if (response.status === 204) {
          this.loaders[action] = false;
          this.localDevice.online = false;
        } else {
          this.loaders[action] = false;
          this.dialogs[action] = false;
        }
      }).catch(err => {
        this.addAlert({
          type: 'error',
          message: `An error occurred. Check console.`,
        });
        console.log(err);
        this.loaders[action] = false;
        this.dialogs[action] = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.headline {
  font-size: large;
  font-weight: 600;
}
.red-btn {
  background-color: red;
  color: white;
  text-transform: none;
  font-family: Roboto;
}
.cnl-btn {
  text-transform: none;
  font-weight: 300;
  font-family: Roboto;
}
.notify-chip{
border-radius: 4px !important; 
height: 16px; 
text-transform: capitalize;
font-weight: 500;
}
.content-title{
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  vertical-align: middle;
  color: var(--v-settingsCardTitle-base) !important;
  margin-top: 0px;
  padding-top: 0px;
  }
.content-card{
  opacity: 1;
  gap: 16px;
  border-radius: 4px;
  padding: 16px;
  background-color: var(--v-settingsCard-base);
  padding: 16px 16px 10px;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>